import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const ProductDetail = () => {
  const { id } = useParams();
  const [product, setProduct] = useState({});
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchProductDetails = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(`http://127.0.0.1:8000/api/products/${id}/`);
        if (!response.ok) {
          throw new Error('Failed to fetch product details');
        }
        const data = await response.json();
        setProduct(data);
      } catch (error) {
        setError('Error fetching product details');
        console.error('Error fetching product details:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchProductDetails();
  }, [id]);

  return (
    <div className="container mx-auto mt-10">
      {isLoading ? (
        <p>Loading...</p>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <div className="grid grid-cols-2 gap-4 mb-6">
            <div className="bg-white w-80 rounded-lg shadow-md p-4">
              <img src={product.image} alt="" className="w-full h-60 object-cover mb-4" />
            </div>
            <div className="bg-white  p-4">
              <h1 className="text-2xl font-semibold mb-4">{product.name}</h1>
              <p className="mb-2"><span className="font-semibold">Description:</span> {product.description}</p>
              <p className="mb-2 "><span className="font-semibold">Price:</span> ksh: {product.price}</p>
              <p className="mb-2 "><span className="font-semibold">Now at:</span> Ksh {product.discount_price}</p>
              <p className="mb-2 "><span className="font-semibold">Save:</span> {product.discount_saving}</p>
              <p className="mb-2 "><span className="font-semibold">Available inventory:</span> {product.inventory_count}</p>
              <p className="mb-2"><span className="font-semibold">Discount Percent:</span> {product.discount_percent}%</p>
            </div>
          </div>
      )}
    </div>
  );
};

export default ProductDetail;
